export interface CreateTireLocationForm {
  location: string;
  allowMultipleUsage: boolean;
  note: string;
}
